import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {PermissionsProvider} from '@/components/common/PermissionsProvider';
import SpiningLoader from '@/components/common/SpinningLoader';
import type {AfriexReferralTier} from '@/types';
import * as formatDate from '@/utils/date';
import {formatName} from '@/utils/formatName';

import SignupBonusUpdateButton from './SignupBonusUpdateButton';
type TierSummaryProp = {
  item: AfriexReferralTier;
  isLoading?: boolean;
  isDetail?: boolean;
};

const SignupBonusSummary = ({item, isLoading}: TierSummaryProp) => {
  const status = item?.isDeactivated ? 'Inactive' : 'Active';

  return isLoading ? (
    <SpiningLoader />
  ) : (
    <div className="bg-white dark:bg-transparent rounded-lg w-full px-5 sm:px-5 py-5 sm:py-5">
      <div className="flex items-center gap-4 mb-3">
        <h2 className="font-semibold text-2xl mr-3">{item.name}</h2>
      </div>

      <div>
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
          <p className="text-slate-500 text-sm dark:text-slate-100">
            Bonus Amount Per User
          </p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item.bonusAmountPerReferree} {item.currencyCode}
          </p>
        </div>

        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
          <p className="text-slate-500 text-sm dark:text-slate-100">
            Referral Code
          </p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item.referralCode}
          </p>
        </div>

        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
          <p className="text-slate-500 text-sm dark:text-slate-100">Status</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {status}
          </p>
        </div>

        {item.admin && (
          <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
            <p className="text-slate-500 text-sm dark:text-slate-100">
              Approved By
            </p>
            <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
              {formatName(item.admin)}
            </p>
          </div>
        )}

        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
          <p className="text-slate-500 text-sm dark:text-slate-100">
            Date Created
          </p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {formatDate.DDMonYYYY(item.createdAt?.toString() || '')}
          </p>
        </div>
      </div>

      <PermissionsProvider
        permission={AfriexAdminPermission.ReferralTierUpdate}
      >
        <div className="flex items-center justify-end gap-6 mt-4">
          <SignupBonusUpdateButton initialData={item} />
        </div>
      </PermissionsProvider>
    </div>
  );
};

export default SignupBonusSummary;
